import React, { useEffect, useState } from "react";
import Page from "../../finwell/pages/Page";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import {
  getModuleListing,
  getModueleListingClear,
  getModuleListingBroker,
  getModuleListingClear,
  getModuleListingClearBroker,
  getCourseDetailEcom,
} from "../../redux/courses/actions";
import { applyTheme, clickStreamUser, SessionKeys } from "../../utils/AppUtils";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import ProgressBar from "react-bootstrap/ProgressBar";
import moment from "moment";
import FooterNew from "../../components/FooterNew";
import HeaderNewMenu from "../../components/HeaderNewMenu";
import ModuleSection from "../../components/Module/ModuleSection";
import CONFIG from "../../utils/config";
import {
  loginBrokerClear,
  loginBrokerResponse,
  loginIframeUserResponse,
} from "../../redux/auth/actions";
import {
  getBrandDetails,
  getBrandTheme,
  setUserRole,
  userDetailBroker,
} from "../../redux/user/actions";
import Loader from "../../components/Loader/Loader";
import $ from "jquery";
import ModuleSectionB2C from "../../components/Module/ModuleSectionB2C";
import RecommendationDetailPage from "../B2C-Pages/RecommendationDetailPage";
import API_LIST from "../../utils/apiList";

const CourseMobileDetail = () => {
  // const history = useHistory();
  const navigate = useNavigate();
  const { courseId } = useParams();
  const dispatch = useDispatch();
  console.log("courseId", courseId);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const token = params.get("token");
  const key = params.get("key");
  const username = params.get("username");
  const email = params.get("email");
  // const source = params.get("source");
  const user_id = params.get("user_id");
  const color_1 = params.get("color_1");
  const color_2 = params.get("color_2");
  const role = params.get("role");
  const apply_theme = params.get("apply_theme");
  // const cid = params.get("cid");

  const via_lp = params.get("via_lp");
  const lp_id = params.get("lp_id");
  const via_cat = params.get("via_cat");
  // const catId = params.get("catId");
  const level_id = params.get("level_id");
  const is_level = params.get("is_level");
  const from = params.get("from");

  const c = params.get("c");
  let decodedString = atob(c);
  let paramsReq = JSON.parse(
    sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES" ? "{}" : decodedString
  );
  const cid = paramsReq.cid;
  const source = paramsReq.source;
  const catId = paramsReq.catId;

  const brandThemeRes = useSelector((state) => state.user.brandThemeRes);

  const auth = useSelector((state) => state.auth.authBroker);
  const moduleListingData = useSelector((state) => state.courses.moduleListing);
  const moduleListingDataBroker = useSelector(
    (state) => state.courses.moduleListingBroker
  );
  const userBranding = useSelector((state) => state.user.userBranding);

  const [moduleList, setModuleList] = useState([]);
  const [moduleData, setModuleData] = useState({});
  const [isValidKey, setIsValidKey] = useState(false);
  const [courseBrokerId, setCourseBrokerId] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (document.getElementById("id_page_404") !== null) {
      document.getElementById("id_page_404").style.display = "none";
    }
    setTimeout(() => {
      if (document.getElementById("cc_div") !== null)
        document.getElementById("cc_div").style.display = "none";
    }, 100);
  }, []);

  useEffect(() => {
    console.log("Branding Data", userBranding);
    if (!_.isEmpty(userBranding)) {
      const branding = userBranding.payload.payload;
      if (!_.isEmpty(branding)) {
        applyTheme(branding);
      }
    }
  }, [userBranding]);
  const addToCartRes = useSelector((state) => state.product.addToCart);
  const activeLanguage = useSelector((state) => state.home.activeLanguage);
  const courseDetailEcom = useSelector(
    (state) => state.courses.courseDetailEcom
  );

  useEffect(() => {
    setIsLoading(false);
    let reqBody = {
      token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
      session_id: localStorage.getItem(SessionKeys.SESSION_ID),
      entity_id: cid,
      language: localStorage.getItem(SessionKeys.SELECTED_LANGUAGE)
    };
    if (from === "lp") {
      reqBody.lp_id = lp_id;
    } else if (from === "bundle") {
      reqBody.bundle_id = lp_id;
    }
    dispatch(
      getCourseDetailEcom({
        URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.COURSE_DETAIL_ECOM}`,
        payload: reqBody,
        method: "post",
        isJSON: true,
        language: activeLanguage
      })
    );
  }, [cid]);

  useEffect(() => {
    console.log("test-", courseDetailEcom);
    if (source === "xsel" || source === "ecom") {
      if (
        !_.isEmpty(courseDetailEcom) &&
        courseDetailEcom.status === "success"
      ) {
        setIsLoading(false);
        // console.log(courseDetailEcom.payload.data)
        let modulesInfo = _.cloneDeep(courseDetailEcom.payload.data);
        modulesInfo?.modules?.sort(
          (a, b) =>
            parseFloat(a.module_sequence) - parseFloat(b.module_sequence)
        );
        if (!_.isEmpty(modulesInfo)) {
          if (modulesInfo.modules.length > 0) {
            modulesInfo.modules[0].isLock = false;
            for (let [index, modules] of modulesInfo.modules.entries()) {
              modules.isLock = modules.isLock === false ? modules.isLock : true;
              if (modules.progress > 0) {
                modules.isLock = false;
                if (index + 1 !== modulesInfo.modules.length)
                  modulesInfo.modules[index + 1].isLock =
                    _.toNumber(modules.progress) === 100 ? false : true;
              }
              if (!token && !modules.is_teaser) {
                modules.isLock = true;
              }
            }
            for (let modules of modulesInfo.modules) {
              const hour = moment(modules.duration, "hh:mm").hours();
              const min = moment(modules.duration, "hh:mm").minutes();
              if (hour > 0) {
                modules.durationTime =
                  hour > 1 ? `${hour} hours` : `${hour} hour`;
              }
              if (min > 0) {
                modules.durationTime =
                  min > 1
                    ? modules.durationTime
                      ? `${modules.durationTime} ${min} minutes`
                      : `${min} minutes`
                    : modules.durationTime
                    ? `${modules.durationTime} ${min} minute`
                    : `${min} minute`;
              }
            }
          }
          setModuleData(modulesInfo);
          // console.log("Modulelisting datas", modulesInfo, source);
        } else {
          setModuleData({});
        }
      }
    } else {
      if (
        !_.isEmpty(moduleListingDataBroker) &&
        moduleListingDataBroker.status === "success"
      ) {
        setIsLoading(false);
        // console.log(moduleListingDataBroker.payload)
        let modulesInfo = _.cloneDeep(moduleListingDataBroker.payload);
        modulesInfo?.modules?.sort(
          (a, b) =>
            parseFloat(a.module_sequence) - parseFloat(b.module_sequence)
        );
        if (!_.isEmpty(modulesInfo)) {
          if (modulesInfo?.modules?.length > 0) {
            setCourseBrokerId(modulesInfo.courseId);
            modulesInfo.modules[0].isLock = false;
            for (let [index, modules] of modulesInfo.modules.entries()) {
              modules.isLock = modules.isLock === false ? modules.isLock : true;
              // module.progress = module.crs_progress
              if (modules.progress > 0) {
                modules.isLock = false;
                if (index + 1 !== modulesInfo.modules.length)
                  modulesInfo.modules[index + 1].isLock =
                    _.toNumber(modules.progress) === 100 ? false : true;
              }

              if (!token && !modules.is_teaser) {
                modules.isLock = true;
              }
            }
            for (let modules of modulesInfo.modules) {
              const hour = moment(modules.time_hrs, "hh").hours();
              const min = moment(modules.time_min, "mm").minutes();
              // module.durationTime = convertTimeFormat(hour * 60 + min)
              // console.log(module.durationTime)
              if (hour > 0) {
                modules.durationTime =
                  hour > 1 ? `${hour} hours` : `${hour} hour`;
              }
              if (min > 0) {
                modules.durationTime =
                  min > 1
                    ? modules.durationTime
                      ? `${modules.durationTime} ${min} minutes`
                      : `${min} minutes`
                    : modules.durationTime
                    ? `${modules.durationTime} ${min} minute`
                    : `${min} minute`;
              }
            }
            if (source === "broker") {
              // console.log('Modulelisting data change module')
              for (let modules of modulesInfo.modules) {
                modules.module_id = modules.id;
              }
            }
          }

          setModuleData(modulesInfo);
          // console.log("Modulelisting data", modulesInfo);
        } else {
          setModuleData({});
        }
      }
    }
  }, [courseDetailEcom, moduleListingDataBroker]);

  // useEffect(() => {
  //     // console.log(moduleListingData)
  //     if (source === 'xsel' || source === 'ecom') {
  //         if (!_.isEmpty(moduleListingData) &&
  //             moduleListingData.status === 'success') {
  //             setIsLoading(false);
  //             // console.log(moduleListingData.payload.payload)
  //             let modulesInfo = _.cloneDeep(moduleListingData.payload.payload)
  //             modulesInfo?.modules?.sort((a, b) => parseFloat(a.module_sequence) - parseFloat(b.module_sequence));
  //             if (!_.isEmpty(modulesInfo)) {
  //                 if (modulesInfo.modules.length > 0) {
  //                     modulesInfo.modules[0].isLock = false;
  //                     for (let [index, modules] of modulesInfo.modules.entries()) {
  //                         modules.isLock = modules.isLock === false ? modules.isLock : true;
  //                         if (modules.progress > 0) {
  //                             modules.isLock = false;
  //                             if ((index + 1) !== modulesInfo.modules.length)
  //                                 modulesInfo.modules[index + 1].isLock = _.toNumber(modules.progress) === 100 ? false : true;
  //                         }
  //                     }
  //                     for (let modules of modulesInfo.modules) {
  //                         const hour = moment(modules.duration, 'hh:mm').hours();
  //                         const min = moment(modules.duration, 'hh:mm').minutes();
  //                         if (hour > 0) {
  //                             modules.durationTime = hour > 1 ? `${hour} hours` : `${hour} hour`;
  //                         }
  //                         if (min > 0) {
  //                             modules.durationTime = min > 1
  //                                 ? modules.durationTime ? `${modules.durationTime} ${min} minutes` : `${min} minutes`
  //                                 : modules.durationTime ? `${modules.durationTime} ${min} minute` : `${min} minute`;
  //                         }
  //                     }
  //                 }
  //                 setModuleData(modulesInfo);
  //                 // console.log("Modulelisting datas", modulesInfo, source);
  //             } else {
  //                 setModuleData({});
  //             }

  //         }
  //     } else {
  //         if (!_.isEmpty(moduleListingDataBroker) &&
  //             moduleListingDataBroker.status === 'success') {
  //             // console.log(moduleListingDataBroker.payload)
  //             setIsLoading(false);
  //             let modulesInfo = _.cloneDeep(moduleListingDataBroker.payload)
  //             modulesInfo?.modules?.sort((a, b) => parseFloat(a.module_sequence) - parseFloat(b.module_sequence));
  //             if (!_.isEmpty(modulesInfo)) {

  //                 if (modulesInfo?.modules?.length > 0) {
  //                     setCourseBrokerId(modulesInfo.courseId)
  //                     modulesInfo.modules[0].isLock = false;
  //                     for (let [index, modules] of modulesInfo.modules.entries()) {
  //                         modules.isLock = modules.isLock === false ? modules.isLock : true;
  //                         if (modules.progress > 0) {
  //                             modules.isLock = false;
  //                             if ((index + 1) !== modulesInfo.modules.length)
  //                                 modulesInfo.modules[index + 1].isLock = _.toNumber(modules.progress) === 100 ? false : true;
  //                         }
  //                     }
  //                     for (let modules of modulesInfo.modules) {
  //                         const hour = moment(modules.time_hrs, 'hh').hours();
  //                         const min = moment(modules.time_min, 'mm').minutes();
  //                         if (hour > 0) {
  //                             modules.durationTime = hour > 1 ? `${hour} hours` : `${hour} hour`;
  //                         }
  //                         if (min > 0) {
  //                             modules.durationTime = min > 1
  //                                 ? modules.durationTime ? `${modules.durationTime} ${min} minutes` : `${min} minutes`
  //                                 : modules.durationTime ? `${modules.durationTime} ${min} minute` : `${min} minute`;
  //                         }
  //                     }
  //                     if (source === 'broker') {
  //                         // console.log('Modulelisting data change module')
  //                         for (let modules of modulesInfo.modules) {
  //                             modules.module_id = modules.id;
  //                         }
  //                     }
  //                 }

  //                 setModuleData(modulesInfo);
  //                 // console.log("Modulelisting data", modulesInfo);
  //             } else {
  //                 setModuleData({});
  //             }

  //         }
  //     }
  //     setIsLoading(false);
  // }, [moduleListingData, moduleListingDataBroker])

  useEffect(() => {
    console.log("auth", auth);
    clickStreamUser("module_detail_page", {
      courseId: courseId,
      userId: auth?.payload?.user.user_id,
    });
  }, [courseId, source, dispatch, auth]);

  useEffect(() => {
    console.log("token", token);
    if (key === CONFIG.KEY.MOBILE_ACCESS_KEY) {
      localStorage.clear();
      // console.log('color', color_1, color_2)
      $("html").css(
        "--color-element-1",
        color_1 ? "#" + color_1 : CONFIG.COLOR_ELEMENT_1
      );
      $("html").css(
        "--color-element-2",
        color_2 ? "#" + color_2 : CONFIG.COLOR_ELEMENT_2
      );
      localStorage.setItem(SessionKeys.API_TOKEN_BROKER, token);
      localStorage.setItem(SessionKeys.API_TOKEN, token);
      localStorage.setItem(SessionKeys.USERNAME, username);
      localStorage.setItem(SessionKeys.USER_ID, user_id);
      sessionStorage.setItem(SessionKeys.COMPLETE_TOUR, "1");
      setIsValidKey(true);
      dispatch(setUserRole(role));

      if (apply_theme === "true") {
        dispatch(
          getBrandTheme({
            module: "getBrandTheme",
            postData: {
              token: token,
            },
          })
        );
        dispatch(
          getBrandDetails({
            module: "getUserBrandingData",
            postData: {
              token: token,
            },
          })
        );
      }

      dispatch(loginBrokerClear());
      if (token) {
        dispatch(
          loginBrokerResponse({
            payload: {
              user: {
                user_id: user_id,
                username: username,
                role: [role],
                email: email,
                branding_primary_color_1: color_1
                  ? color_1
                  : CONFIG.COLOR_ELEMENT_1,
                branding_primary_color_2: color_2
                  ? color_2
                  : CONFIG.COLOR_ELEMENT_2,
                apply_theme: apply_theme === "true" ? true : false,
              },
              apiToken: token,
            },
          })
        );
        dispatch(
          loginIframeUserResponse({
            payload: {
              user: {
                user_id: user_id,
                username: username,
                role: [role],
              },
              apiToken: token,
            },
          })
        );

        dispatch(
          userDetailBroker({
            module: "getOrderDetailBroker",
            apiToken: token,
          })
        );
      }
      console.log(courseId, source);
      if (courseId && (source === "xsel" || source === "ecom")) {
        // if (!_.isEmpty(auth)) {
        console.log("executing getNIITAdminModule", source, courseId, auth);
        setIsLoading(true);
        dispatch(getModuleListingClear());
        dispatch(
          getModuleListing({
            module: "getNIITAdminModule",
            postData: {
              user_id: user_id,
              course_id: courseId,
            },
          })
        );
        // }
      } else {
        console.log("executing get_all_course_modules", source, courseId, auth);
        console.log(courseId);
        dispatch(getModuleListingClearBroker());
        setIsLoading(true);
        dispatch(
          getModuleListingBroker({
            module: "get_all_course_modules",
            token: token,
            courseId: courseId,
            language: activeLanguage
          })
        );
      }
      clickStreamUser("module_detail_page_from_mobile", {
        courseId: courseId,
        userId: auth?.payload?.user.user_id,
      });
    } else {
      setIsLoading(false);
    }
  }, [token, key, user_id, dispatch]);

  useEffect(() => {
    console.log("brandThemeRes: ", brandThemeRes);
    if (!_.isEmpty(brandThemeRes)) {
      if (brandThemeRes?.status === "success") {
        const branding = brandThemeRes.payload.payload.branding;
        // !_.isEmpty(branding) && applyTheme(branding)
      }
    }
  }, [brandThemeRes]);

  const navigateToDetails = (title, progress, m) => {
    if (!m.isLock) {
      // console.log("Module", m);
      let courseID = source === "broker" ? courseBrokerId : courseId;
      clickStreamUser("module_click_goto", {
        moduleId: m.module_id,
        moduleName: m.title,
        courseName: moduleData.courseName,
        courseId: courseID,
        userId: auth?.authBroker?.payload.user.user_id,
      });
      let paramsReq = {
        source: source,
        cid: cid,
      };
      if (from === "lp" || via_lp === "true") {
        paramsReq.via_lp = "true";
        paramsReq.lp_id = lp_id;
        if (is_level === "true") {
          paramsReq.is_level = "true";
          paramsReq.level_id = level_id;
        }
      } else if (via_cat === "true") {
        paramsReq.via_cat = "true";
        paramsReq.cat_id = catId;
      }
      let jsonString = JSON.stringify(paramsReq);
      let encodedUrl = btoa(jsonString);

      let pathname = `/course/module/launch/${courseId}?c=${encodedUrl}`;
      // console.log('VIA LP', via_lp, lp_id)
      // if (via_lp === "true") {
      //     pathname += `&via_lp=true&lp_id=${lp_id}`
      //     if (is_level === 'true') {
      //         pathname += `&is_level=true&level_id=${level_id}`
      //     }
      // } else if (via_cat === 'true') {
      //     pathname += `&via_cat=true&cat_id=${catId}`
      // }
      navigate(pathname, {
        state: {
          courseId: courseID,
          courseCode: courseId,
          courseTitle: title,
          courseProgress: progress,
          mId: m.module_id,
          module: m,
        },
      });
      // history.push({
      //     pathname,
      //     // pathname: `moduleDetail/${courseId}/courseDetail`,
      //     state: { courseId: courseID, courseCode: courseId, courseTitle: title, courseProgress: progress, mId: m.module_id, module: m }
      // })
    }
  };

  useEffect(() => {
    console.log("check--", moduleData);
  }, [moduleData]);

  return (
    <>
      {isValidKey ? (
        <>
          <Loader start={isLoading} />
          <ModuleSectionB2C
            navigateToDetails={navigateToDetails}
            moduleListData={moduleData}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            isMobile={true}
          />
          <RecommendationDetailPage isMobile={true} />
          {/*<FooterNew />*/}
        </>
      ) : (
        <div>{isLoading ? "" : "Invalid Key"}</div>
      )}
    </>
  );
};
export default CourseMobileDetail;
